((d, s, id) => {
  let js = d.getElementsByTagName(s)[0]
  const fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')



// WEBPACK FOOTER //
// ./src/assets/js/facebookSDK.js